/**
 * SpineDrawing — the animated SVG mark used by the splash intro.
 * Pure presentational: draws head, spine, and 7 vertebra ribs with
 * CSS keyframes. Kept separate so it can be re-used or restyled later.
 */
export default function SpineDrawing({ width = 120, height = 140 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="ph-spine-svg"
    >
      {/* Head */}
      <circle cx="60" cy="14" r="10" className="ph-head" />

      {/* Spine path */}
      <path
        d="M60 24 C 58 40, 63 55, 60 70 C 57 85, 63 100, 60 118 L60 132"
        className="ph-spine"
        strokeLinecap="round"
      />

      {/* Vertebrae ribs */}
      {[36, 48, 60, 72, 84, 96, 108].map((y, i) => (
        <line
          key={y}
          x1={i % 2 === 0 ? 48 : 50}
          y1={y}
          x2={i % 2 === 0 ? 72 : 70}
          y2={y}
          className={`ph-vert ph-vert-${i}`}
          strokeLinecap="round"
        />
      ))}
    </svg>
  );
}
